import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import NikeBrandPage from "@/pages/brands/nike/page";
import AdidasBrandPage from "@/pages/brands/adidas/page";
import SupremeBrandPage from "@/pages/brands/supreme/page";
import CssbuyVsKakobuyPage from "@/pages/comparison/cssbuy-vs-kakobuy/page";
import CssbuyVsSuperbuyPage from "@/pages/comparison/cssbuy-vs-superbuy/page";
import KakobuyVsSuperbuyPage from "@/pages/comparison/kakobuy-vs-superbuy/page";
import ShippingGuidePage from "@/pages/guides/shipping/page";
import QCGuidePage from "@/pages/guides/qc/page";
import KakobuyHubPage from "@/pages/kakobuy-spreadsheet/page";
import SuperbuyHubPage from "@/pages/superbuy-spreadsheet/page";
import OopbuyHubPage from "@/pages/oopbuy-spreadsheet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-sheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/brands/nike",
    element: <NikeBrandPage />,
  },
  {
    path: "/brands/adidas",
    element: <AdidasBrandPage />,
  },
  {
    path: "/brands/supreme",
    element: <SupremeBrandPage />,
  },
  {
    path: "/comparison/cssbuy-vs-kakobuy",
    element: <CssbuyVsKakobuyPage />,
  },
  {
    path: "/comparison/cssbuy-vs-superbuy",
    element: <CssbuyVsSuperbuyPage />,
  },
  {
    path: "/comparison/kakobuy-vs-superbuy",
    element: <KakobuyVsSuperbuyPage />,
  },
  {
    path: "/guides/shipping",
    element: <ShippingGuidePage />,
  },
  {
    path: "/guides/qc",
    element: <QCGuidePage />,
  },
  {
    path: "/kakobuy-spreadsheet",
    element: <KakobuyHubPage />,
  },
  {
    path: "/superbuy-spreadsheet",
    element: <SuperbuyHubPage />,
  },
  {
    path: "/oopbuy-spreadsheet",
    element: <OopbuyHubPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;